export const eventsLinks = [
  {
    label: "landingPage:eventsLinks.musicFestival",
    href: "https://panel.tix.skey.dev/event-info/f2569447-5d84-4e96-874e-4c7daeecefe4",
    target: "_blank"
  },
  {
    label: "landingPage:eventsLinks.businessConference",
    href: "https://panel.tix.skey.dev/event-info/c270f937-7609-4cad-aa61-90e66cfcf422",
    target: "_blank"
  }
];
